export const PLACEHOLDER = 'placeholder';

export const LIVE_CLASSROOM_TABS = {
  COMMON_ISSUES: 'Common Issues - Action Needed'
};

export const EMBER_STATUSES = {
  IN_PROGRESS: 'in_progress',
  NOT_AVAILABLE: 'not__available',
  NOT_STARTED: 'not_started'
};

export const HUMAN_GENERATED = 'Human generated';
export const AI_GENERATED = 'AI generated';

export const DOLLAR_SIGN = '$';
export const ESCAPED_DOLLAR = '__ESCAPED_DOLLAR__';

export const MATH_FIELD = 'math-field';

export const USER_TYPE = 'user';

export const LIVE_CLASSROOM_TEACHERS_DOMAIN = [
  'dpsnc.net',
  'leadpublicschools.org',
  'pgcps.org',
  'aacps.org',
  'cfschools.net',
  'becomingschools.org',
  'globalprepindy.org'
];
